import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class WeekDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 0; // 0 es Domingo, 1 sería Lunes
  }

  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'week') {
      const weekStart = this.getStartOfWeek(date);
      const weekEnd = this.addDays(weekStart, 6);
      return `${this.formatDate(weekStart)} - ${this.formatDate(weekEnd)}`;
    }
    return super.format(date, displayFormat);
  }

  getStartOfWeek(date: Date): Date {
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Ajusta para el primer día de la semana
    return new Date(date.setDate(diff));
  }

  addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(date.getDate() + days);
    return result;
  }

  formatDate(date: Date): string {
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  }
}
